import {keys, mapKeys, omitBy} from "lodash"


export default (obj, keyMap) => {
  const allowedKeys = keys(keyMap)
  const validKeys = omitBy(obj, (value, key) => allowedKeys.indexOf(key) < 0)
  return mapKeys(validKeys, (value, key) => keyMap[key])
}
